import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@1trading/react';

const PlaceholderPage = ({ title }: { title: string }) => {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-2xl font-semibold">{title}</h1>
      <Card className="max-w-xl">
        <CardHeader>
          <CardTitle>Not migrated yet</CardTitle>
          <CardDescription>This screen has not been ported to the new portal yet — use the legacy portal in the meantime.</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">See docs/PLAN.md for the phase in which this screen lands.</p>
        </CardContent>
      </Card>
    </div>
  );
};
PlaceholderPage.displayName = 'PlaceholderPage';

export default PlaceholderPage;
